"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoldFormLabel = exports.BoldFormLabelArgs = void 0;
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_form_label_1 = require("./il-form-label");
// arguments
exports.BoldFormLabelArgs = {
    color: enums_1.ColorPaletteEnum.PRIMARY,
    sx: {
        fontWeight: 'bold',
    },
};
exports.BoldFormLabel = (0, get_component_1.getComponent)(il_form_label_1.IlFormLabel, exports.BoldFormLabelArgs);
